<template>
  <div class="footer" style="background-color: var(--footer-color); padding: 15px 0">
    <div class="container">
      <div class="row" style="padding: 0 20px">
        <div v-if="twoColumn" class="col-sm-grow" style="min-width: 300px; max-width: 310px"></div>
        <div class="col-12 q-px-md-md" :class="twoColumn ? 'col-sm-grow two-column' : ''">
          <div class="contact" v-if="region == 'NZ'">
            <div class="title q-py-sm">
              <h6><b>Contact</b></h6>
            </div>
            <!-- <h6>FleetPartners New Zealand</h6> -->
            <!-- <p>P: <a href="tel:0800 438 435">0800 438 435</a></p>
            <p>E: <a href="mailto:Service@fleetpartners.co.nz">Service@fleetpartners.co.nz</a></p> -->

            <!-- white label -->
            <h6>{{ companyName }}</h6>
            <p>
              P: <a :href="`tel:${contacts.phone}`">{{ contacts.phone }}</a>
            </p>
            <p>
              E: <a :href="`mailto:${contacts.email}`">{{ contacts.email }}</a>
            </p>
            <br /><br />
          </div>
          <div class="contact" v-else>
            <div class="title q-py-sm">
              <h6><b>Contact</b></h6>
            </div>
            <!-- <h6>FleetPartners Australia</h6> -->
            <!-- <p>P: <a href="tel:1300 666 001">1300 666 001</a></p>
            <p>E: <a href="mailto:channel@fleetpartners.com.au">channel@fleetpartners.com.au</a></p>
            <p><a href="https://www.fleetpartners.com.au/" target="_blank">www.fleetpartners.com.au</a></p> -->

            <!-- white label -->
            <h6>{{ companyName }}</h6>
            <p>
              P: <a :href="`tel:${contacts.phone}`">{{ contacts.phone }}</a>
            </p>
            <p>
              E: <a :href="`mailto:${contacts.email}`">{{ contacts.email }}</a>
            </p>
            <p>
              <a :href="`https://${contacts.website}`" target="_blank">{{ contacts.website }}</a>
            </p>
            <!-- <br />
            <h6>MMBA</h6>
            <p>P: <a href="tel:1300 020 272">1300 020 272</a></p>
            <p>
              E:
              <a href="mailto:MMBA@mitsubishibusinessadvantage.com.au"
                >MMBA@mitsubishibusinessadvantage.com.au</a
              >
            </p>
            <br /><br /> -->
          </div>
          <div class="logout q-my-lg">
            <div class="row items-center" style="border-bottom: 1px solid rgba(255, 255, 255, 0.3); padding: 5px 0px">
              <div class="col-xs-2 col-sm-2 col-md-1">
                <img src="/assets/icons/message-white.svg" />
              </div>
              <div class="col-xs-10 col-sm-10 col-md-11">
                <a
                  :href="region == 'NZ' ? 'mailto:Service@fleetpartners.co.nz' : 'mailto:channel@fleetpartners.com.au'"
                  class="q-py-sm"
                  style="margin-left: -25px"
                >
                  Give FeedBack</a
                >
              </div>
            </div>
            <div class="row items-center" style="padding: 5px 0px">
              <div class="col-xs-2 col-sm-2 col-md-1">
                <img src="/assets/icons/logout.svg" />
              </div>
              <div class="col-xs-10 col-sm-10 col-md-11">
                <a href="/logout" class="q-py-sm" style="margin-left: -25px"> Logout</a>
              </div>
            </div>
          </div>
          <div class="terms">
            <!-- <p>
              {{ organisationName }}
            </p> -->
            <p v-if="orgProfile.footerText" v-html="`${orgProfile.footerText}`"></p>
            <p v-else>&copy; FleetPartners Pty Ltd is a wholly owned subsidiary of Eclipx</p>
            <p v-if="!orgProfile.footerText">Group Limited ABN 85 131 557 901 ASX:ECX</p>
          </div>
          <div class="links">
            <!-- <a
              :href="region == 'NZ' ? 'https://www.fleetpartners.co.nz/terms-of-use' : 'https://www.fleetpartners.com.au/terms-of-use'"
              target="_blank"
              >Terms of Use</a
            >
            <a href="https://eclipxgroup.com/privacy-policy" target="_blank">Privacy Policy</a> -->

            <!-- white Label -->
            <a :href="termsPolicy.terms" target="_blank">Terms of Use</a>
            <a :href="termsPolicy.policy" target="_blank">Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * This component represents the header which is to be displayed as part of all page layouts.
 */
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'Footer',
  props: {
    twoColumn: Boolean
  },
  data() {
    return {
      organisationLogoPlaceholder: `${process.env.BASE_URL}assets/logos/EclipxLogo-small.svg`
    };
  },
  computed: {
    ...mapState({
      scoreboard: (state) =>
        state.vehicleApplication?.vehicleApplication?.scoreboard ? state.vehicleApplication?.vehicleApplication?.scoreboard : null
    }),
    ...mapGetters({
      orgProfile: 'theme/getScoreboard',
      whiteLabel: 'theme/getWhitelabel'
    }),
    region() {
      return this.scoreboard?.currentUser?.region ? this.scoreboard?.currentUser?.region : 'AU';
    },
    organisationName() {
      return this.scoreboard?.currentUser?.orgName ? this.scoreboard?.currentUser?.orgName : '';
    },
    companyName() {
      if (this.region == 'AU') {
        return this.whiteLabel?.introducerName ? this.whiteLabel.introducerName : 'FleetPartners Australia';
      } else {
        return this.whiteLabel?.introducerName ? this.whiteLabel.introducerName : 'FleetPartners New Zealand';
      }
    },
    contacts() {
      if (this.region == 'AU') {
        return {
          phone: this.orgProfile.phoneNumber || '1300 666 001',
          email: this.orgProfile.email || 'channel@fleetpartners.com.au',
          website: this.orgProfile.website || 'www.fleetpartners.com.au'
        };
      } else {
        return {
          phone: this.orgProfile.phoneNumber || '0800 438 435',
          email: this.orgProfile.email || 'Service@fleetpartners.co.nz'
        };
      }
    },
    termsPolicy() {
      let terms;
      if (this.region == 'NZ') {
        terms = this.whiteLabel.termsLink || 'https://www.fleetpartners.co.nz/terms-of-use';
      } else {
        terms = this.whiteLabel.termsLink || 'https://www.fleetpartners.com.au/terms-of-use';
      }
      return {
        terms,
        policy: this.whiteLabel.privacyPolicy || 'https://eclipxgroup.com/privacy-policy'
      };
    }
  },
  methods: {
    logout() {
      this.$router.push({ name: 'logout' });
    }
  }
};
</script>

<style lang="sass" scoped>
a
  white-space: nowrap;
.footer

p
    margin: 0 0 5px 0;
.logout
  border-top: 1px solid rgba(255,255,255,0.3);
  border-bottom: 1px solid rgba(255,255,255,0.3);
.logout a
  display: block;
  font-size: 16px;
  font-weight: 700;
.terms
  font-size: 12px;
  line-height: 17px;
  color: rgba(255,255,255,0.8)
.links a
  font-size: 12px;
.links a:after
  content: '';
  display: inline-block;
  padding-right: 7px;
  margin-right: 7px;
  border-right: 1px solid;
  height: 10px;
.links a:last-child:after
  border-right: 0;
.logout img
  vertical-align: text-top;
  padding-right: 5px;
.two-column
  max-width: calc(100% - 310px)
</style>
